// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__NPbYR","page__spinner":"styles_page__spinner__MIrmj"};